// extracted by mini-css-extract-plugin
export default {"box":"Social_box__OyxCb","socialBox":"Social_socialBox__iTJJd","socialText":"Social_socialText__wJP7S"};